import CustomTable from "@/components/CustomTable/CustomTable.vue";
import { format_date } from "@/utils/date_formatter";
import NavBar from '@/components/NavBar/NavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { useToast } from "@/components/Toast/useToast";

export default {
  name: 'TemplateManagement',
  mixins: [LOGOUT],
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning
    };
  },
  components: {
    NavBar,
    CustomTable
  },
  data: () => ({
    templates: [],
    template_types: [],
    workflows: [],
    template_type: '',
    uploaded_file: null,
    template_name:'',
    template_description: '',
    new_template_type: '',
    loading: false,
    columns: [
      { label: "Template Name", key: "template_name" },
      { label: "Description", key: "description" },
      { label: "Date Created", key: "date_created" },
      { label: "Template Type", key: "template_type" },
    ],
   }),
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    get_template_types(){
      const TOKEN = localStorage.getItem('token');
      const GET_TEMPLATE_TYPES_URL = `${API_BASE_URL}/verify_api/template_management_api/template_types_api/`;
      
      $.ajax({
        url: GET_TEMPLATE_TYPES_URL,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          this.loading = true;
        },
        success: (response) => {
          this.template_types = response.data;
          this.loading = false; // Set loading to false after data is loaded
        },
        error: () => {
          this.loading = false; // Ensure loading is false even if there's an error
          this.showError('Error getting template types');
        }
      });
    },

    on_file_change(event) {
      const FILE = event.target.files[0];
      const MAX_SIZE = 5 * 1024 * 1024;
      if (FILE.size > MAX_SIZE) {
        event.target.value = null;
        this.showWarning('File is too large (max 5MB).');
        return;
      }
      if (FILE.type !== "application/pdf") {
        event.target.value = null;
        this.showWarning('Unsupported file type. Please upload a PDF file.');
        return;
      }
      this.uploaded_file = FILE;
    },

    create_new_template(){

        if (!this.template_name.trim()) {
          this.showWarning('Please enter a template name.');
          return;
        }
      
        if (!this.uploaded_file) {
          this.showWarning('Please upload a file.');
          return;
        }
      
        if (!this.template_type) {
          this.showWarning('Please select a template type.');
          return;
        }

        if (!this.template_description) {
          this.showWarning('Please enter template description.');
          return;
        }
      
        if (this.template_type === 'Other' && !this.new_template_type.trim()) {
          this.showWarning('Please enter a new template type.');
          return;
        }
      
        const TOKEN = localStorage.getItem('token');
        const CREATE_TEMPLATE_URL = `${API_BASE_URL}/verify_api/template_management_api/add_template_api/`;
        let final_template_type = this.template_type;
      
        if (this.template_type === 'Other') {
          final_template_type = this.new_template_type;
        }
        
        const FORM_DATA = new FormData();
        FORM_DATA.append('template_name', this.template_name);
        FORM_DATA.append('template_type',final_template_type);
        FORM_DATA.append('template_description', this.template_description);
        FORM_DATA.append('template_file', this.uploaded_file);
    
      $.ajax({
        method: "POST",
        url: CREATE_TEMPLATE_URL,
        data: FORM_DATA,
        processData: false, 
        contentType: false,
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {

        },
        success: () => { 
          // Close the modal first
          $('#add_template_modal').modal('hide');
          
          // Show success message
          this.showSuccess('Template created successfully');
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        },
        error: (error) => {
          this.showError(error.responseJSON?.error || 'An error occurred while creating the template');
        }
      });
    },
    
    get_templates(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/template_management_api/get_paginated_templates_api/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (data) => {
            resolve({
              count: data.count,
              results: data.results,
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          },
        });
      });
    },

    assign_to_workflow(template){
      if (template) {
        this.template_id = template.id;
        this.template_name = template.template_name;
        this.$nextTick(() => {
          $('#assign_template_modal').modal('show');
        });
      }
    },

    get_client_workflows() {
      const TOKEN = localStorage.getItem('token');
      const GET_WORKFLOWS_API = `${API_BASE_URL}/verify_api/template_management_api/get_workflows_api/`;
  
      $.ajax({
        url: GET_WORKFLOWS_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          this.loading = true;

        },
        success: (response) => {
          this.workflows = response || []; // Handle null or non-array responses
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.showError('Failed to load workflows');
        }
      });
    },

    add_template(){
      this.$nextTick(() => {
        $('#add_template_modal').modal('show');
      });
    },

    assign_workflow(workflow_id){

      const TOKEN = localStorage.getItem('token');
      const ASSIGN_TO_WORKFLOW_URL = `${API_BASE_URL}/verify_api/template_management_api/assign_template_to_workflow_api/`;
      
      const FORM_DATA = {
        workflow_id: workflow_id,
        template_id: this.template_id,

      };

      $.ajax({
          method: "POST",
          url: ASSIGN_TO_WORKFLOW_URL,
          data: JSON.stringify(FORM_DATA),
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
  
          },
          success: (response) => {
            this.showSuccess(response.status || 'Template assigned to workflow successfully');
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          },
          error: (error) => {
            this.showError(error.responseJSON?.error || 'Failed to assign template to workflow');
          }
        });

    },

    view_template_configuration(template_id){
      this.$router.push({ name: 'template_configuration', params: { template_id} });
    }

},
mounted() {
    if (!validateToken(this.$router)) {
        return;
    }
    this.get_templates();
    this.get_template_types();
    this.get_client_workflows();
}
};
